<template>
  <div class="modal fade" :id="id" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="options.roomType">เลือกห้องสำหรับ {{options.roomType.name}}</h5>
          <h5 class="modal-title" v-else>เลือกห้อง</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div v-for="(roomsInFloor, floor) in preparedRooms" :key="floor">
              <div class="d-flex mt-2">
                <div class="mr-auto">ชั้นที่ {{floor}}</div>
                <div>
                  <button type="button" class="btn btn-secondary mr-2" @click="resetFloor(floor)"><i class="fas fa-sync-alt"></i> รีเซ็ต</button>
                  <button type="button" class="btn btn-success" @click="selectFloor(floor)">เลือกทั้งชั้น</button>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mt-1 mb-1" v-for="(room, index) in roomsInFloor" :key="index">
                  <div class="text-center" 
                  style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                    {{room.get('roomId')}}
                  </div>
                  <div
                    v-if="!room.roomType || isSameRoomSelected(room.roomType)" 
                    class="room-icon text-center" 
                    :class="{
                      'room-selected': roomSelected[floor][room.get('roomId')].isSelected
                    }" 
                    @click="selectRoom(floor, room)"
                  >
                    <i
                      v-if="roomSelected[floor][room.get('roomId')].isSelected" 
                      class="fas fa-check fa-4x" 
                      style="color: white; line-height: 100px; margin: auto;"></i>
                  </div>
                  <div class="room-icon text-center room-icon-selected" v-else>
                    <div class="selected-room">
                      {{room.roomType.name}}
                    </div>
                  </div>
                  <div class="text-center" v-if="room.get('roomRate')">
                    {{room.totalCost}} บาท/เดือน
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" v-if="countSelectedRooms()" @click="save">เลือก {{countSelectedRooms()}} ห้อง</button>
          <!-- <button type="button" class="btn btn-primary" v-else @click="save">ไม่เลือกห้อง</button> -->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ['id','rooms', 'onSelected', 'options', 'onClose'],
  data() {
    return {
      roomSelected: {},
      roomType: null
    }
  },
  created() {
    if(this.rooms) {
      this.rooms.forEach(room => {
        if(!this.roomSelected[room.get('floor')]) this.roomSelected[room.get('floor')] = {}
        this.roomSelected[room.get('floor')][room.get('roomId')] = { 
          isSelected: false, 
          room
        }
      })
    }
  },
  mounted() {
    // eslint-disable-next-line
    $(`#${this.id}`).on('hidden.bs.modal', () => {
      if(this.onClose && typeof this.onClose === 'function') this.onClose()
    })
  },
  methods: {
    init() {
      this.roomSelected = {}
      //check for room
      if(this.rooms) {
        this.rooms.forEach(room => {
          if(room.get('roomRate')) {
            let roomCost = 0
            if(room.get('roomRate').get('roomCost_month') ) roomCost = room.get('roomRate').get('roomCost_month') 
            room.totalCost = roomCost + this.getFurnitureCost(room)
          }else{
            room.totalCost = 0
          }
          if(!this.roomSelected[room.get('floor')]) this.roomSelected[room.get('floor')] = {}
          if(this.isSameRoomSelected(room.roomType)) {
            this.roomSelected[room.get('floor')][room.get('roomId')] = { 
              isSelected: true,
              room
            }
          }else{
            this.roomSelected[room.get('floor')][room.get('roomId')] = {
              isSelected: false,
              room
            }
          }
        })
      }
      if(this.options.roomType) this.roomType = this.options.roomType
    },
    selectRoom(floor, room) {
      this.roomSelected[floor][room.get('roomId')].isSelected =!this.roomSelected[floor][room.get('roomId')].isSelected;
      this.$mount()
    },
    selectFloor(floor) {
      this.rooms.map((room) => {
        if(floor == room.get('floor')) {
          if(!room.roomType || this.isSameRoomSelected(room.roomType)) this.roomSelected[floor][room.get('roomId')].isSelected = true
        }
      })
      this.$mount()
    },
    resetFloor(floor) {
      this.rooms.map((room) => {
        if(floor == room.get('floor')) {
          if(!room.roomType || this.isSameRoomSelected(room.roomType)) this.roomSelected[floor][room.get('roomId')].isSelected = false
        }
      })
      this.$mount()
    },
    countSelectedRooms() {
      let count = 0
      for(let floor in this.roomSelected) {
        for(let roomId in this.roomSelected[floor]) {
          if(this.roomSelected[floor][roomId].isSelected){
            count ++
          }
        }
      }
      return count
    },
    save() {
      if(this.onSelected && typeof this.onSelected === 'function') {
        let roomsSelected = []
        for(let floor in this.roomSelected) {
          for(let roomId in this.roomSelected[floor]) {
            if(this.roomSelected[floor][roomId].isSelected){
              roomsSelected.push(this.roomSelected[floor][roomId].room)
            }
          }
        }
        if(this.options.roomType) {
          this.options.roomType.roomsSelected = roomsSelected
          this.onSelected(roomsSelected, this.options.roomType)
        }else{
          this.onSelected(roomsSelected)
        }
        // eslint-disable-next-line
        $(`#${this.id}`).modal('hide')
      }
    },
    isSameRoomSelected(roomType) {
      if(!roomType) return false
      if(!this.options.roomType) return false
      if(roomType.objectId === this.options.roomType.objectId) return true
    },
    getFurnitureCost(room) {
      if(room.get('servicesRate')) {
        for(let cost of room.get('servicesRate')) {
          if(cost['name_en']==='Furniture rate') {
            if(cost['cost_month']) return cost['cost_month']
            else return 0
          }
        }
      }
      return 0
    }
  },
  computed: {
    preparedRooms() {
      if(!this.rooms) {
        return []
      } else {
        let preparedRooms = {}
        this.rooms.forEach(room => {
          if(!preparedRooms[room.get('floor')]) preparedRooms[room.get('floor')] = []
          preparedRooms[room.get('floor')].push(room)
        })
        return preparedRooms
      }
    },
  },
  watch: {
    options: {
      handler() {
        if(this.options.isShow) {
          this.init()
          // eslint-disable-next-line
          $(`#${this.id}`).modal()
        }else{
          // eslint-disable-next-line
          $(`#${this.id}`).modal('hide')
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/color.scss';

.room-icon {
  border-radius: 0.25em;
  background-color: #6c757d;
  height: 100px;
  width: 100px;
  margin: auto;
  cursor: pointer;
}
.room-icon-selected {
  border: $primary-color 1px solid;
  background-color: #FFF5E9;
  color: $primary-color;
}

.room-selected {
  background-color: $primary-color;
}

.selected-room {
  line-height: 100px;
  margin: auto;
  cursor: not-allowed;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

